<template>
  <div>
    <div class="images-container">
      <div>
        <div class="d-flex align-items-center side-frame-success mt-3">
          <span
            class="side-frame-text"
            style="font-size: 15px; font-weight: 700"
          >
            {{ $l('form_label_selective_color') || '可选颜色' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <div v-if="!disabled" style="display: flex">
            <el-upload
              id="uploader"
              ref="uploader"
              multiple
              action="#"
              :file-list="listImage"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="uploadChange"
              accept=".jpeg,.jpg,.png,.gif"
            >
              <b-button
                class="mr-2"
                style="width: 70px"
                size="sm"
                variant="outline-primary"
                >{{ $l('INDEX.btn_upload') || '上传' }}
              </b-button>
            </el-upload>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="chooseImageDisabled = true"
              >{{ $l('form_label_choose_image') || '从调研图片选' }}
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="mainImageSetColor"
              >{{ $l('form_label_set_main_image') || '将主图设置为颜色' }}
            </b-button>
          </div>
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
        "
      >
        <div v-for="(item, index) in listImage" :key="index">
          <div class="mt-1 mr-2 mb-2" style="width: 150px; padding: 1px">
            <div style="width: 150px; height: 100px">
              <div class="image-box">
                <span class="default-icon" v-if="item.isDefault === 'Y'">
                  <i class="el-icon-success"></i>
                </span>
                <el-image
                  style="width: 100%; height: 100%"
                  fit="scale-down"
                  :src="
                    item.thumbImageUrl
                      ? $osscdn(item.thumbImageUrl)
                      : '/image/static/img/nopic.jpg'
                  "
                >
                  <div slot="error" class="image-slot">
                    <img
                      src="/image/static/img/nopic.jpg"
                      style="width: 150px; height: 100px"
                    /></div
                ></el-image>
                <div class="shadow">
                  <div>
                    <span @click="onImagePreview(index)">
                      <i class="el-icon-zoom-in"></i
                    ></span>
                    <span
                      v-if="!disabled"
                      @click="onImageDel(item)"
                      class="ml-2"
                    >
                      <i class="el-icon-delete-solid"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="margin-left: 5px !important; margin-right: 3px !important"
            >
              <el-form :model="item" size="small" :disabled="disabled">
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-form-item
                      :label="$l('form_label_colorNo') || '编号'"
                      prop="scmColorNo"
                    >
                      <el-input
                        v-model="item.scmColorNo"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入'
                        "
                        maxlength="200"
                        size="mini"
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" class="mb-2">
                    <el-form-item
                      :label="$l('form_label_colorName') || '名称'"
                      prop="colorName"
                    >
                      <el-input
                        v-model="item.colorName"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入'
                        "
                        maxlength="200"
                        size="mini"
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>

    <ChooseImage
      v-if="chooseImageDisabled"
      @reload="getData"
      @close="closeChooseImage"
      :visible="chooseImageDisabled"
      :resFabricScmCode="resFabricScmCode"
      :resFabricInfoCode="resFabricInfoCode"
      :title="$l('form_label_choose_image') || '从调研照片中选择'"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import ChooseImage from '../choose-image'

export default {
  mixins: [EditLoading],
  components: { ChooseImage },
  props: {
    resFabricInfoCode: { type: String, default: '' },
    resFabricScmCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    title: {
      type: String,
      default: '图片维护',
    },
  },
  data() {
    return {
      listImage: [],
      imagePaths: [],
      listImageFile: [],
      uploadFileMaxLimit: 10,
      chooseImageDisabled: false,
    }
  },
  computed: {
    isEmpty() {
      return !this.listImage || !this.listImage.length
    },
    listImageUrl() {
      return this.isEmpty ? [] : this.listImage.map((item) => item.imageUrl)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.resFabricInfoCode) return
      const res = await this.$api
        .resFabricInfoColorListApi({
          resFabricInfoCode: this.resFabricInfoCode,
          isLocalImg: 'N',
        })
        .catch(() => null)
      this.listImage = res.body.data
    },
    uploadChange(file) {
      const $uploader = this.$refs.uploader
      const uploader = $uploader.$el.querySelectorAll('input')[0]

      const listFile = uploader.files
      const fileCount = listFile.length

      if (fileCount > this.uploadFileMaxLimit) {
        const msg = `当前限制选择 ${this.uploadFileMaxLimit} 张图片，本次选择了 ${fileCount} 张图片`
        this.$message.warning(msg)
        this.clearFiles()
        throw new Error(msg)
      }
      this.listImageFile.push(file)
      if (this.listImageFile.length !== fileCount) return false
      this.upload()
    },
    async upload() {
      if (!this.listImageFile || !this.listImageFile.length) {
        this.$message.warning('请选择您需要上传的图片！')
        return
      }
      this.loadingOpen()
      const listImage = await this.uploadImages()
      if (listImage.includes(null)) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        this.loadingClose()
        this.clearFiles()
        return
      }

      const params = { resFabricInfoCode: this.resFabricInfoCode, listImage }

      const res = await this.$api
        .resFabricInfoColorUploadApi(params)
        .catch(() => null)
      this.loadingClose()
      this.clearFiles()
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.getData()
    },
    uploadImages() {
      if (!this.listImageFile || !this.listImageFile.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listImageFile.map(({ raw }) => {
        return this.$api
          .SYS_UPLOAD(raw)
          .then((res) => ({
            imageCode: res.body.fileId,
            imageUrl: res.body.url,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    clearFiles() {
      this.$refs.uploader.clearFiles()
      this.listImageFile = []
    },
    getTableData() {
      return this.listImage.map((m) => {
        return {
          resFabricInfoColorCode: m.resFabricInfoColorCode,
          scmColorNo: m.scmColorNo,
          colorName: m.colorName,
        }
      })
    },
    onImageDel({ resFabricInfoColorCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .resFabricInfoColorDelApi({ resFabricInfoColorCode })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
              return
            }
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    async mainImageSetColor() {
      this.loadingOpen()
      await this.$api
        .resFabricInfoImg2ColorApi({
          resFabricInfoCode: this.resFabricInfoCode,
        })
        .then(async () => {
          await this.getData()
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    closeChooseImage() {
      this.chooseImageDisabled = false
    },
    onImagePreview(index) {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
  },
}
</script>
<style lang="scss" scoped>
.images-container {
  min-height: 302px;
}

.el-form-item {
  margin-bottom: 0px;
}

.side-frame-success {
  padding: 1px 5px 0 5px;
  border-left: 3px solid $color-primary;
  height: 26px;
}

.image-box {
  width: 150px;
  height: 100px;
  position: relative;
  background-color: #fbfdff;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
